<style src="./Confirm.scss" lang="scss"></style>

<template lang="pug">
  .confirm
    .confirm__header
      h1.confirm__title {{ title }}
    .confirm__body
      .confirm__buttons
        .confirm__button(
          @click='yes'
        )
          Button(
            :label='$l10n("YES")'
            class-list='is-wide is-white'
          )
        .confirm__button(
          @click='no'
        )
          Button(
            :label='$l10n("NO")'
            class-list='is-wide is-white'
          )
      p.confirm__text(
        v-if='caption'
      ) {{ caption }}
</template>
<script>
import Button from "@/components/Button/Button";

import { mapActions } from "vuex";

export default {
  name: "ConfirmTemplate",
  props: {
    title: String,
    caption: String
  },
  components: { Button },
  methods: {
    ...mapActions({
      closeModal: "modal/close"
    }),
    yes() {
      this.closeModal({ confirm: true });
    },
    no() {
      this.closeModal({ confirm: false });
    }
  }
};
</script>
